export default [
   {
      name: 'JavaScript',
      value: 'js',
      icon: 'javascript',
      fusionTimeAbility: true,
   },
   {
      name: 'React',
      value: 'react',
      icon: 'react',
      fusionTimeAbility: true,
   },
   {
      name: 'Angular',
      value: 'angular4',
      icon: 'angular4',
      fusionTimeAbility: true,
   },
   {
      name: 'jQuery',
      value: 'jquery',
      icon: 'jquery',
      fusionTimeAbility: true,
   },
   {
      name: 'Vue',
      value: 'vue',
      icon: 'vue',
      fusionTimeAbility: true,
   },
   {
      name: 'Ember',
      value: 'ember',
      icon: 'ember',
      fusionTimeAbility: true,
   },
   {
      name: 'Svelte',
      value: 'svelte',
      icon: 'svelte',
      fusionTimeAbility: true,
   },
   {
      name: 'React Native',
      value: 'react-native',
      icon: 'react',
      fusionTimeAbility: false,
   },
   {
      name: 'AngularJS',
      value: 'angular',
      icon: 'angular',
      fusionTimeAbility: true,
   },
   {
      name: 'PHP',
      value: 'php',
      icon: 'php',
      fusionTimeAbility: true,
   },
   {
      name: 'Ruby on Rails',
      value: 'rails',
      icon: 'ror',
      fusionTimeAbility: false,
   },
   {
      name: 'ASP.NET (C#)',
      value: 'csharp',
      icon: 'dotnet',
      fusionTimeAbility: true,
   },
   {
      name: 'ASP.NET (VB)',
      value: 'vb',
      icon: 'dotnet',
      fusionTimeAbility: false,
   },
   {
      name: 'Python',
      value: 'python',
      icon: 'python',
      fusionTimeAbility: true,
   },
];
